import PropTypes from 'prop-types'
import React from 'react'

export default function Product({ product }) {
  return (
    <div className="template-product">
      <div>{product.name}</div>
    </div>
  )
}

Product.propTypes = { product: PropTypes.object.isRequired }
